import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_hub/$customerId/dashboard/annual-cycle")({
    component: RouteComponent,
    staticData: {
        titleFn: null,
    },
});

function RouteComponent() {
    const { customerId } = Route.useParams();

    return <Navigate to="/$customerId/dashboard" params={{ customerId }} replace />;
}
